import PropTypes from 'prop-types'
import {useQuery} from '@tanstack/react-query'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'

const MAX_DISTANCE = 100

export const getStores = async ({parameters, getTokenWhenReady, proxy}) => {
    const customApi = new CustomApi()
    const token = await getTokenWhenReady()

    try {
        const apiName = 'store-search'
        const endpointPath = '/'
        const urlParams = {
            c_maxDistance: MAX_DISTANCE,
            ...parameters
        }
        const response = await customApi.get(token, apiName, endpointPath, urlParams, proxy)

        return {
            stores: response?.stores || []
        }
    } catch (error) {
        logger.error('Error fetching Search Store', {
            namespace: 'useStoreSearch.getStores',
            additionalProperties: {error}
        })
        throw error
    }
}

export const useStoreSearch = ({parameters, options}) => {
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig
    const {getTokenWhenReady} = useAccessToken()
    return useQuery({
        queryKey: ['use-store-search', parameters],
        queryFn: () => getStores({parameters, getTokenWhenReady, proxy}),
        enabled: options?.enabled,
        keepPreviousData: true,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false
    })
}

useStoreSearch.propTypes = {
    parameters: PropTypes.shape({
        zip: PropTypes.string,
        lat: PropTypes.number,
        long: PropTypes.number
    }),
    options: PropTypes.shape({
        enabled: PropTypes.bool
    })
}
